import React from "react";

import InputSender from "../InputSender";
import styles from "../Footer.module.scss";

const PedidoDemonstracao = () => (
    <>
        <h2 className={styles.requestDemoTitle}>Solicite uma demonstração</h2>
        <InputSender />
    </>
);

export default PedidoDemonstracao;
